
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet, RouterModule } from '@angular/router';
import { SharedService } from '../../shared/services/shared.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-golf-digest-login-layout',
    imports: [RouterOutlet, RouterModule],
    templateUrl: './golf-digest-login-layout.component.html',
    styleUrl: './golf-digest-login-layout.component.scss'
})
export class GolfDigestLoginLayoutComponent {
  constructor(
    private _sharedService: SharedService
  ){
  }
  ngOnInit(): void {
    // this._sharedService.loading.set(false);
  }
}
